_require ['jquery/select2v3', 'jquery/select2', 'shared/campus_map'], ->
  updLandingUrl = (city, regionSlug, courseName, courseSlug)->
    link = $('#course-map-link')
    if !regionSlug || regionSlug is '--'
      link.empty()
    else if !courseName || !courseSlug
      link.html("Veja outras faculdades em <span class='text-nowrap'>#{city} > </span>")
      link.attr('href', "/faculdades-e-universidades/#{regionSlug}/todas")
    else
      link.html("Veja outros cursos de #{courseName} em <span class='text-nowrap'>#{city} > </span>")
      link.attr('href', "/cursos-e-faculdades/#{regionSlug}/#{courseSlug}/todos")

  $selectCampusPrivate = $('#js-fetch-campus')
  $selectCampusPublic = $('.js-fetch-public-campus')
  $CampusPublicCourses = $('.js-fetch-public-campus-courses')

  if $selectCampusPrivate.length
    fetcher = $selectCampusPrivate
    # _require ['jquery/select2v3'], ->
    # init select2
    select2Options =
      containerCssClass: 'qb-s2v3'
      dropdownCssClass: 'qb-s2v3'
      placeholder: 'Selecione um campus...'
      formatNoMatches: (term)->
        return "Nenhum campus contendo '#{term}' encontrado."
      formatSearching: ->
        return "Buscando campus..."
      formatLoadMore: (page)->
        return "Carregando mais campus..."

    fetcher.select2V3(select2Options)

  else if $selectCampusPublic.length
    fetcher = $selectCampusPublic
    # init select2
    select2Options =
      theme: 'normal-m'
      placeholder: 'Selecione um campus...'
      formatNoMatches: (term)->
        return "Nenhum campus contendo '#{term}' encontrado."
      formatSearching: ->
        return "Buscando campus..."
      formatLoadMore: (page)->
        return "Carregando mais campus..."

    fetcher.select2(select2Options)

  else
    fetcher = $CampusPublicCourses

  skipLoad = (element) ->
    skip = element.attr('data-skip-load')
    return skip == 'true'

  if fetcher.length
    map = new QB.CampusMap (locData) ->
      $('.js-campus-addr').text(locData.fullAddr)
      courseName = $("#canonical_course_name").val()
      courseSlug = $("#canonical_course_slug").val()
      updLandingUrl(locData.city, locData.slug, courseName, courseSlug)
      return

    campusId = fetcher.val()
    universityId = fetcher.attr('data-university')
    map.reloadCampusMap(campusId, universityId, '#map-canvas') if campusId && !skipLoad(fetcher)

    fetcher.on 'change', ->
      campusId = $(this).val()
      universityId = fetcher.attr('data-university')
      map.reloadCampusMap(campusId, universityId, '#map-canvas') if campusId && !skipLoad(fetcher)

      fetcher.removeAttr('data-skip-load')

    fetcher.trigger 'change'
